import { LOCATION_CONFIGS, LOCATION_PLATFORM } from "../locationConstants";

function getDesktopPlatformSearchByMobileSearch(search: string) {
    try {
        const [pathName, searchParams] = search.split('?');
        const searchParamsArr = searchParams.split('&');
        const configs = Object.values(LOCATION_CONFIGS);
        const resultArr = searchParamsArr.reduce((acc, initialValue) => {
            const targetConfig = configs.find(configs => configs[LOCATION_PLATFORM.MOBILE]?.search === initialValue);
            return [...acc, targetConfig?.[LOCATION_PLATFORM.DESKTOP]?.search || initialValue];
        }, []);
        return `${pathName}?${resultArr.join('&')}`;
    } catch (e) {
        return search;
    }
}

export default getDesktopPlatformSearchByMobileSearch;
